"use strict";

var _interopRequireDefault = require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js"));
var _react = _interopRequireDefault(require("react"));
var _Checkbox = _interopRequireDefault(require("../Checkbox"));
var _toDisplayCase = _interopRequireDefault(require("../toDisplayCase"));
var _excluded = ["id", "field", "label", "value", "defaultValue"];
var _jsxFileName = "/Users/mweeb/Desktop/codings/nq-component/src/InputBoolean/index.js";
var noop = function noop() {};
var defaultProps = {
  onChange: noop
};
function InputBoolean(_ref) {
  var id = _ref.id,
    field = _ref.field,
    label = _ref.label,
    value = _ref.value,
    defaultValue = _ref.defaultValue,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], Object.assign({
    id: id || field,
    label: label || (0, _toDisplayCase["default"])(field),
    checked: value,
    defaultChecked: defaultValue
  }, props, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 12,
      columnNumber: 13
    }
  }));
}
InputBoolean.defaultProps = defaultProps;
var _default = InputBoolean;
exports["default"] = _default;